export enum CONTRIBUTION_TYPE {
  BANK_TRANSFER_ONLINE = 'BANK_TRANSFER_ONLINE',
  BANK_TRANSFER_OFFLINE = 'BANK_TRANSFER_OFFLINE',
  CREDIT_CARD = 'CREDIT_CARD',
  DONOR_ADVISED_FUND = 'DONOR_ADVISED_FUND',
  PHYSICAL_CHECK = 'PHYSICAL_CHECK',
  PUBLICLY_TRADED_SECURITIES = 'PUBLICLY_TRADED_SECURITIES',
  OTHER_ASSETS = 'OTHER_ASSETS',
  SEPA_DEBIT = 'SEPA_DEBIT',
  BANK_TRANSFER = 'BANK_TRANSFER',
}

export interface ContributionType {
  code: CONTRIBUTION_TYPE;
  displayName: string;
}

export const ContributionTypes: ContributionType[] = [
  {
    code: CONTRIBUTION_TYPE.BANK_TRANSFER_ONLINE,
    displayName: 'contribute.contribution_type.bank_transfer_online',
  },
  {
    code: CONTRIBUTION_TYPE.BANK_TRANSFER_OFFLINE,
    displayName: 'contribute.contribution_type.bank_transfer_offline',
  },
  {
    code: CONTRIBUTION_TYPE.CREDIT_CARD,
    displayName: 'contribute.contribution_type.credit_card',
  },
  {
    code: CONTRIBUTION_TYPE.DONOR_ADVISED_FUND,
    displayName: 'contribute.contribution_type.donor_advised_fund',
  },
  {
    code: CONTRIBUTION_TYPE.PHYSICAL_CHECK,
    displayName: 'contribute.contribution_type.physical_check',
  },
  {
    code: CONTRIBUTION_TYPE.PUBLICLY_TRADED_SECURITIES,
    displayName: 'contribute.contribution_type.publicly_traded_securities',
  },
  {
    code: CONTRIBUTION_TYPE.OTHER_ASSETS,
    displayName: 'contribute.contribution_type.other_assets',
  },
  {
    code: CONTRIBUTION_TYPE.SEPA_DEBIT,
    displayName: 'contribute.contribution_type.sepa_debit',
  },
];